<template>
  <Card :btnMsg="$t('formBasic.btn_text')" @changeStep="changeStep">
    <div class="card-formBasic">
      <LanguageS class="language-btn-box"></LanguageS>
      <div class="card-content">
        <p class="card-title" v-html="$t('formBasic.title')"></p>
        <a-form-model ref="formBasic" :model="form" :rules="formRules">
          <div class="code-box">
            <a-form-model-item :label="$t('formBasic.form_name')" prop="nick_name">
              <a-input :placeholder="$t('formBasic.form_name_placeholder')" v-model="form.nick_name" size="large" type="primary"></a-input>
            </a-form-model-item>
            <a-form-model-item :label="$t('formBasic.form_email')" prop="email">
              <a-input :placeholder="$t('formBasic.form_email_placeholder')" v-model="form.email" size="large" type="primary"></a-input>
            </a-form-model-item>
            <a-form-model-item label="" prop="order_id">
              <div class="order-q-box">
                <label :title="$t('formBasic.form_order')" class="ant-form-item-required point" v-html="$t('formBasic.form_order')"></label>
                <div @click="jumpOrderDetails" class="order-q point">?</div>
              </div>
              <a-input
                v-model="form.order_id"
                size="large"
                type="primary"
                :placeholder="$t('formBasic.form_order_placeholder')"
                @input="formatOrderNumber"
              />
            </a-form-model-item>
          </div>
        </a-form-model>
        <div class="order-why-box">
          <span class="order-why point" @click="jumpOrderDetails">{{ $t('formBasic.order_why') }}</span>
          <span class="order-answer">{{ $t('formBasic.order_answer') }}</span>
        </div>
      </div>
    </div>
  </Card>
</template>

<script>
import Card from '@/components/card.vue';
import LanguageS from '@/components/language.vue';
import { postValidateCode } from '@/api/portal';
export default {
  components: {
    Card,
    LanguageS,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {},
      formRules: {
        nick_name: [{ required: true, message: this.$t('formBasic.form_name_placeholder'), trigger: 'blur' }],
        email: [
          { required: true, message: this.$t('formBasic.form_email_placeholder'), trigger: 'blur' },
          {
            // 使用方案一的正则表达式
            pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            message: this.$t('formBasic.form_email_error_placeholder'),
            trigger: 'change',
          }
        ],
        order_id: [
          { required: true, message: this.$t('formBasic.form_order_placeholder'), trigger: 'blur' },
          {
            pattern: /^\d{3}-\d{7}-\d{7}$/,
            message: this.$t('formBasic.form_order_error_placeholder'),
            trigger: 'change',
          },
          {
            pattern: /^\d{3}-\d{7}-\d{7}$/,
            message: this.$t('formBasic.form_order_error_placeholder'),
            trigger: 'blur',
          },
        ],
      },
    };
  },
  mounted() {
    this.form = this.value;
  },
  watch: {
    '$i18n.locale': {
      handler() {
        this.formRules = {
          nick_name: [{ required: true, message: this.$t('formBasic.form_name_placeholder'), trigger: 'blur' }],
          email: [
            { required: true, message: this.$t('formBasic.form_email_placeholder'), trigger: 'blur' },
            {
              pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
              message: this.$t('formBasic.form_email_error_placeholder'),
              trigger: 'change',
            },
          ],
          order_id: [
            { required: true, message: this.$t('formBasic.form_order_placeholder'), trigger: 'blur' },
            {
              pattern: /^\d{3}-\d{7}-\d{7}$/,
              message: this.$t('formBasic.form_order_error_placeholder'),
              trigger: 'change',
            },
            {
              pattern: /^\d{3}-\d{7}-\d{7}$/,
              message: this.$t('formBasic.form_order_error_placeholder'),
              trigger: 'blur',
            },
          ],
        };
        this.$nextTick(_ => {
          this.checkForm();
        });
      },
    },
  },
  methods: {
    checkForm() {
      let bol = false;
      this.$refs.formBasic.validate(valid => {
        if (valid) {
          bol = true;
          return true;
        } else {
          bol = false;
          return false;
        }
      });
      this.$nextTick(_ => {});
      return bol;
    },
    changeStep() {
      let bol = this.checkForm();
      if (bol) {
        postValidateCode({
          ...this.form,
        })
          .then(res => {
            let {default_channels,good_review_channels,questions} = res.data
            this.form={...this.form,default_channels,good_review_channels,questions}
            // if(res.data.last_record_data){
            //   // 这里做状态储存
            //   // let curnData = res.data.last_record_data;
            //   this.$emit('input', { ...this.form, ...curnData,email:this.form.email,nick_name:this.form.nick_name });
            //   // this.$parent.changeStep(res.data.last_record_step,);
            //   this.$parent.changeStep('showGiftCard');
            // }else{
              this.$emit('input', this.form);
              this.$parent.changeStep('showGiftCard',this.form);
            // }
          })
          .catch(res => {
            if (res.data.code === 103) {
              this.$parent.changeStep('thanks');
            }
          });
      }
    },
    formatOrderNumber(e) {
      // 获取输入框的值和当前光标位置
      let input = e.target.value;
      let position = e.target.selectionStart; // 当前光标位置
      // 去除非数字和多余的连字符
      input = input.replace(/[^0-9]/g, '');

      // 插入连字符
      if (input.length > 3) {
        input = input.slice(0, 3) + '-' + input.slice(3);
        if (position === 4) position++; // 调整光标位置
      }
      if (input.length > 11) {
        input = input.slice(0, 11) + '-' + input.slice(11);
        if (position === 12) position++; // 调整光标位置
      }

      // 限制最大长度
      input = input.slice(0, 19);

      // 更新绑定数据
      this.form.order_id = input;

      // 更新输入框的值
      e.target.value = input;

      // 恢复光标位置
      e.target.setSelectionRange(position, position);
    },
    jumpOrderDetails() {
      // this.$router.push('order-flow');
      window.open(`${location.origin}/order-flow`, '_blank');
    },
  },
};
</script>

<style lang="scss">
.point {
  cursor: pointer;
}
.card-formBasic {
  position: relative;
  width: 100%;
  .card-title {
    font-size: 24px;
    font-weight: 500;
    color: #1a1a1a;
    margin-bottom: 20px;
  }
  .order-q-box {
    display: flex;
    align-items: center;
    gap: 10px;
    .order-q {
      line-height: 24px;
      text-align: center;
      font-size: 18px;
      border-radius: 50%;
      width: 24px;
      height: 24px;
      background-color: #ffd814;
      font-weight: 500;
    }
  }
  .card-text {
    font-size: 17px;
    font-weight: 400;
    color: #1a1a1a;
    margin-bottom: 20px;
  }
  .order-why-box {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    .order-why {
      font-size: 16px;
      font-weight: 400;
      color: #f40000;
    }
    .order-answer {
      font-size: 16px;
      font-weight: 500;
      color: #1a1a1a;
    }
  }
  .van-swipe__indicator .van-swipe__indicator-item {
    background-color: #fff;
  }

  .van-swipe__indicator .van-swipe__indicator-item--active {
    background-color: #f4a300; /* 高亮颜色 */
  }
}
</style>
